import DataTable from 'components/Core/DataTable';
import React, { useEffect, useMemo, useRef,useState } from 'react';
import Purchaser from '../../lib/Core/Backend/Controllers/Purchaser';
import Notify from 'lib/Utils/Alert';
import ReactNotificationAlert from 'react-notification-alert';
import $ from 'jquery';
import { Modal, ModalHeader,
  ModalBody,
  Button,
  ModalFooter,
   } from 'reactstrap';
import { callback } from 'chart.js/helpers';


const ContactManager = ({contacts, contactType, token,purchaser}) => {
  const purchaserCtl = useMemo(() => new Purchaser(token),[token]);
  const [warningModal,setWarningModal] = useState(false)
  
  const toggleWarning = () => setWarningModal(!warningModal);
  const alert = useRef();
  const table = useRef();

  const sendCredentials = (row) => {
    const contact = row.data();
    const newUser = {
      acceptPrivacyPolicy: true,
      acceptTermsAndConditions: true,
      firstName:contact.contactFirstName,
      lastName: contact.contactLastName,
      phoneNumber: contact.phone,
      representativeUser: true,
      userManager: true,
      username: contact.email
    }
    purchaserCtl.addPurchaserUser(contact.purchaserId, contact.id, newUser, data => {
      if(data.error || data.errorMessage){
        Notify(alert, 'danger', data.errorMessage ?? data.error);
      } else {
        row.data({...row.data(), userId: data.id}).draw();
      }
    })
    
  }

  useEffect(() => {
    $(function () {
      $('[data-toggle="tooltip"]').tooltip()
    })
    if(table.current)
      table.current.dataTable.rows.add(contacts).draw();
  }, [contacts])

const deleteContact = (row) =>{
  purchaserCtl.disableUser(purchaser.id, row.data().id, (data) => {
    if(data?.status == 403){
      toggleWarning();
    }
    if (data && !data.error) {
      purchaserCtl.contacts(purchaser.id, (data) => {
        if (data && !data.error) {

          if (table.current) {
            table.current.dataTable.clear().rows.add(data).draw();
          }
        } else {
          Notify(alert, 'danger', data.error);
        }
      });
    } else {
      if(data?.error === "Server error response code: 403. Unable to parse response body."){

      }else{
        Notify(alert, "danger", data.errorMessage ?? data.error);
      }
      // Notify(alert, 'danger', data.error);
    }
  });
}
  return (
    <>
    <div>
      <ReactNotificationAlert ref={alert} />
      <div className='table-responsive'>

      <DataTable ref={table}
				data={null}
				columns={[
				  
				  {title: "First Name", data: "contactFirstName"},
				  {title: "Last Name", data: "contactLastName"},
          {title: "Email",data: "email",
            render: (data) => data.toLowerCase()
          },
          {
				   title: "Contact Type", data: "purchaserContactTypeId", render: data =>
				   {
					   const ct = contactType.find(item => item.id === parseInt(data));
					   return !!ct ? ct.name : contactType.length > 0 ? "No Contact Type" : "Loading...";
				   }
				  },
				  // {title: "", data: "userId", render: data =>
          //   {
          //     if(data !== null) {
          //       return `<button class='btn text-info ncentiva-send-credentials-btn' data-toggle="tooltip" data-placement="top" title="Send forgot password" style='padding: 5px 10px; background: transparent'><i class="fas fa-key"></i></button>`
          //     }else return '';
          //   }
          // },
         
				]}
        addBtnsFromData={[{callback: sendCredentials, selector: 'button.ncentiva-send-credentials-btn'}]}
        addRemoveButton={{callback:deleteContact}}
				options={{dom: "tr"}}
			/>
      </div>
    </div>
    <Modal isOpen={warningModal} toggle={toggleWarning} backdrop="static">
            <ModalHeader className="bg-warning" toggle={toggleWarning}>Access Denied</ModalHeader>
            <ModalBody>
                <p className="card-just-text">
				You do not have access to perform this action
                </p>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggleWarning}>Close</Button>
            </ModalFooter>
        </Modal>

   </> 
  );
}
 
export default ContactManager;